module.exports = __webpack_public_path__ + "static/images/styles/images/dots-pattern-x.9adf32e9.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/dots-pattern-x.png
// module id = 3622
// module chunks = 11